import { z } from "zod";
import { addToast } from "../../../toasts";
import { importService } from "../../../services/importService";
import { disableButton, enableButton } from "../../../lib/utility";
import { createFormFieldHandler } from "../../../utils/form-handler";

export function RequestImportForm(data = {
    platform: '',
    platform_name: '',
}, idPrefix = 'form-unique') {

    const formSchema = z.object({
        search: z.string().min(1, "Search is required"),
        platform: z.string().min(1, "Platform is required"),
    });

    type FormData = z.infer<typeof formSchema>;
    let $formElem: null | HTMLFormElement = null;
    let $submitButton: null | HTMLButtonElement = null;

    function init() {
        $formElem = document.getElementById(`${idPrefix}-manual-import-request-form`) as HTMLFormElement;
        $submitButton = $formElem.querySelector(`#${idPrefix}-btn-request-manual-import`) as HTMLButtonElement;
        if (!($formElem && $submitButton)) {
            console.error("Can't find all the form elements!");
        }

        const { setFieldError, validateOnBlur } = createFormFieldHandler(
            formSchema,
            $formElem
        );
      
        // Add event listeners to form fields to validate on blur
        validateOnBlur();
          
        // Handle form submission
        $formElem.addEventListener("submit", async (e) => {
            e.preventDefault();
            const formData = new FormData($formElem!);
            const data = Object.fromEntries(formData.entries()) as FormData;

            try {
                formSchema.parse(data);
                disableButton($submitButton!);
                try {
                    const createImportReqResp:any = await importService.manualImportRequest(formData);
                    addToast({ toastBody: createImportReqResp.message }, "default", "success");
                    $formElem!.reset();
                } catch (error: any) {
                    // this catch block is for handling Server errors on the request
                    console.error("Get import feed request failed: ", error);
                    addToast({ toastBody: error.message }, "default", "error");
                    error.errors && Object.keys(error.errors).forEach((field) => {
                        // Display each error message for the corresponding field
                        setFieldError(field as keyof FormData, error.errors[field][0]);
                    });
                }
            } catch (error) {
                // this catch block is for handling Frontend form validation
                if (error instanceof z.ZodError) {
                  error.errors.forEach((err) => {
                    setFieldError(err.path[0] as keyof FormData, err.message);
                  });
                }
            } finally {
                enableButton($submitButton!);
            }
        });
    }
    
    function render() {
        return /*html*/`
        <form id="${idPrefix}-manual-import-request-form">
            <div class="flex flex-row items-start gap-2 max-w-full">
                <input type="hidden" name="platform" value="${data.platform}">
                <input type="text"
                    name="search"
                    class="py-2.5 px-3 block w-full border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-transparent dark:border-neutral-700 dark:text-neutral-300 dark:placeholder:text-white/60 dark:focus:ring-neutral-600"
                    placeholder="Enter ${data.platform_name} review link">
                <button id="${idPrefix}-btn-request-manual-import" type="submit"
                    class="btn btn-sm btn-solid">
                    <span class="btn-label flex gap-x-1 items-center">
                    Request
                    <span/>
                </button>
            </div>
        </form>
        `;
    }

    return {
        init,
        render,
    };
}